export const FETCH_HOME_LAYOUT = 'FETCH_HOME_LAYOUT';
export const FETCH_HOME_LAYOUT_SUCCESS = 'FETCH_HOME_LAYOUT_SUCCESS';
export const FETCH_HOME_LAYOUT_FAILURE = 'FETCH_HOME_LAYOUT_FAILURE';

export const FETCH_MARKET_DATA = 'FETCH_MARKET_DATA';
export const FETCH_MARKET_DATA_SUCCESS = 'FETCH_MARKET_DATA_SUCCESS';
export const FETCH_MARKET_DATA_FAILURE = 'FETCH_MARKET_DATA_FAILURE';

export const FETCH_HOME_PAGE_DATA = 'FETCH_HOME_PAGE_DATA';
export const FETCH_HOME_PAGE_DATA_SUCCESS = 'FETCH_HOME_PAGE_DATA_SUCCESS';
export const FETCH_HOME_PAGE_DATA_FAILURE = 'FETCH_HOME_PAGE_DATA_FAILURE';
